import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import styled from "styled-components";

class NewMain extends Component {
  // constructor(props) {}

  render() {
    const { t } = this.props;
    return (
      <MainWrapper>
        <ContentText>
          <TitleText>
            <p>Energy monitoring Platform</p>
            <img src="/images/ctors/frame/head/logo_naxa.svg" alt="NEXA" />
          </TitleText>
          <SubText>
            {t("key4.line1")}
            <br />
            {t("key4.line2")}
            <br />
            {t("key4.line3")}
          </SubText>
        </ContentText>
        <ContentImage>
          <img src="/images/ctors/main_visual_image.png" alt="" />
        </ContentImage>
      </MainWrapper>
    );
  }
}
const MainWrapper = styled.div`
  max-width: 1200px;
  width: 100%;
  height: 810px;
  margin: 0 auto;
  position: relative;
`;
const ContentText = styled.div`
  position: absolute;
  top: 246px;
  left: 0;
  z-index: 2;
  /* padding: 246px 0 0 0; */
`;
const TitleText = styled.h1`
  font-weight: bold;
  font-size: 75px;
  margin-bottom: 15px;
  p {
    font-size: 30px;
    font-weight: 600;
  }
  img {
    height: 75px;
    width: auto;
    margin: 20px 0;
  }
`;
const SubText = styled.p`
  font-size: 20px;
  line-height: 32px;
  font-weight: 500;
`;
const ContentImage = styled.div`
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  z-index: 1;
  img {
    width: 876px;
    height: auto;
  }
`;
export default withTranslation()(NewMain);
